import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useDeviceType from "../../custom-hooks/DeviceType";
import useHasOverflow from "../../custom-hooks/HasOverflow";
import { TEXT_CONSTANTS } from "../../utils/text-constants/textConstants";
import MenuDropdown from "../../component-lib/Molecules/menuDropdown/MenuDropdown";
import {
  getStockStatusBackground,
  getStockStatusDotColor,
  getStockStatusTextColor,
} from "../../utils/statusConstants";

import { plusIcon, searchIcon, DownloadIcon } from "../../assets";
import WrapperCard from "../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import EventEHRTabs from "../../component-lib/Molecules/tabs/EventEHRTabs";
import SearchSelectDropdown from "../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import SelectDropdown from "../../component-lib/Atoms/Select/Select";
import { INVENTORY_TYPE_OPTIONS } from "../reports-screen/ReportConstants";
import Button from "../../component-lib/Molecules/button/Button";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import EventEHRSimpleCard from "../../component-lib/Molecules/card/EventEHRSimpleCard";
import AddNewInventoryDialog from "./dialogs/AddNewInventory";
import ImportInventoryDialog from "./dialogs/ImportInventory";
import ImportResultsDialog from "./dialogs/ImportResultsDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  componentKey,
  setCloseInventoryDialog,
  setCloseSendInventoryDialog,
} from "./InventorySlice";
import {
  addInventoryList,
  deleteInventory,
  getInventoryList,
  updateInventoryList,
  sendInventoryToFacility,
} from "./InventorySaga";
import InventoryService from "../../services/InventoryService";
import ViewInventoryDialog from "./dialogs/ViewInventoryDialog";
import SendInventoryDialog from "../facility-management-screen/facility-details/dialogs/SendInventoryDialog";
import { getInventoryData } from "./contstant";
import EventEHRConfirmationDialog from "../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import { handleImportData } from "../../utils/handleImportData ";
const InventoryScreen = () => {
  const { inventoryList, closeInventoryDialog, closeSendInventoryDialog } =
    useSelector(
      (state: Record<string, unknown>) =>
        state[componentKey] as Record<string, unknown>,
    );
  const [searchParams] = useSearchParams();
  const defaultSelectedStock = searchParams.get("selectedStock"); // Replace 'yourParam' with your parameter name

  // YOU CAN USE THIS TYPE FOR BUTTON
  const commonButtonStyle = {
    paddingTop: "6px",
    paddingBottom: "6px",
    minWidth: "155px",
  };
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const divRef = useRef<HTMLDivElement>(null);
  const hasOverflow = useHasOverflow(divRef);
  const [rowPerPage, setRowPerPage] = useState("10");
  const [searchedValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState(1);
  const [categoryType, setCategoryType] = useState("");

  // THIS IS THE SELECTED TAB USE STATE
  const [selectedTab, setSelectedTab] = useState(
    defaultSelectedStock === "lsa" ? "lsa" : "allInventory",
  );

  // OPEN ADD PROVIDER USER DIALOG
  const [openAddInventoryDialog, setOpenAddInventoryDialog] = useState(false);
  const [openImportInventoryDialog, setOpenImportInventoryDialog] =
    useState(false);
  const [openViewInventoryDialog, setOpenViewInventoryDialog] = useState(false);
  const [defaultDataForInventory, setDefaultDataForInventory] = useState<
    Record<string, unknown>
  >({});
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedInventoryId, setSelectedInventoryId] = useState<string | null>(
    null,
  );

  // SEND INVENTORY (main → facility): single + bulk
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [openSendDialog, setOpenSendDialog] = useState(false);
  const [transferItems, setTransferItems] = useState<any[]>([]);
  const [isSingleTransfer, setIsSingleTransfer] = useState(false);
  // Bumped to remount the table and clear its selection after a send.
  const [tableResetKey, setTableResetKey] = useState(0);
  const [isImporting, setIsImporting] = useState(false);
  const [importMessage, setImportMessage] = useState<string | null>(null);
  const [openImportResultsDialog, setOpenImportResultsDialog] = useState(false);
  const [importResults, setImportResults] = useState<{
    summary: {
      totalRecords: number;
      validRecords: number;
      invalidRecords: number;
      createdInventory: number;
      totalProcessed: number;
    };
    valid: Array<Record<string, unknown>>;
    invalid: Array<{
      index: number;
      reason: string;
      row: Record<string, unknown>;
    }>;
    message: string;
  } | null>(null);

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Dashboard simple cardS
  const cardsData = [
    {
      title: "Total Inventory",
      value: (inventoryList as any)?.count?.totalStocks || "0",
    },
    { title: "In Stock", value: (inventoryList as any)?.count?.inStock || "0" },
    {
      title: "Low Stock",
      value: (inventoryList as any)?.count?.lowStock || "0",
    },
    {
      title: "Out Of Stock",
      value: (inventoryList as any)?.count?.outOfStock || "0",
    },
  ];

  // ALL INVENTORY COLUMN DATA
  const allInventoryTabColumns = [
    {
      field: "itemID",
      label: <div>Item ID</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          // <p className=" text-primary-main font-normal font-weight-500">
          <p className=" text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.itemID ? String(row.itemID) : ""}
          </p>
        );
      },
    },
    {
      field: "itemName",
      label: <div>Item Name</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          <p className=" text-neutral-90 font-normal">
            {row?.itemName ? String(row.itemName) : ""}
          </p>
        );
      },
    },
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          <p className="text-neutral-90 font-normal">
            {row?.category ? String(row.category) : ""}
          </p>
        );
      },
    },
    {
      field: "currentStock",
      label: <div>Current Stock</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          <p className="text-neutral-90 font-normal">
            {String(row?.currentStock ?? "-")}
          </p>
        );
      },
    },
    {
      field: "reorderPoint",
      label: <div>Reorder Point</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          <p className="text-neutral-90 font-normal">
            {row?.reorderPoint ? String(row.reorderPoint) : ""}
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Stock Status</div>,
      renderLogic: (row: Record<string, unknown>) => {
        const status = row?.status ? String(row.status) : "";
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1"
              style={{
                color: getStockStatusTextColor(status),
                background: getStockStatusBackground(status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <img src={getStockStatusDotColor(status)} alt={status} />
              {status}
            </span>
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: Record<string, unknown>) => {
        return (
          <div className="flex items-center">
            <MenuDropdown
              options={[
                {
                  label: "View Inventory",
                  onClickCb: () => {
                    setDefaultDataForInventory(row);
                    setOpenViewInventoryDialog(true);
                  },
                },
                {
                  label: "Edit Inventory",
                  onClickCb: () => {
                    setDefaultDataForInventory(row);
                    setOpenAddInventoryDialog(true);
                  },
                },
                {
                  label: "Send Inventory",
                  disabled:
                    Number(row?.currentStock) === 0 ||
                    row?.status === "Out of Stock",
                  onClickCb: () => {
                    setTransferItems([
                      {
                        id: row?.id,
                        itemName: row?.itemName,
                        stockLevel: row?.currentStock,
                      },
                    ]);
                    setIsSingleTransfer(true);
                    setOpenSendDialog(true);
                  },
                },
                {
                  label: "Delete Inventory",
                  onClickCb: () => {
                    setSelectedInventoryId(row?.id as string);
                    setOpenConfirmationDialog(true);
                  },
                },
              ]}
            />
          </div>
        );
      },
    },
  ];

  // INVENTORY LIST ROW DATA
  const inventoryRowData = getInventoryData(inventoryList);

  useEffect(() => {
    getInventory();
  }, [searchedValue, rowPerPage, pageNumber, selectedTab, categoryType]);

  useEffect(() => {
    if (closeInventoryDialog) {
      dispatch(setCloseInventoryDialog(false));
      setOpenAddInventoryDialog(false);
      setOpenImportInventoryDialog(false);
      getInventory();
      setOpenConfirmationDialog(false); // for delete contact confirmation dialog(for api failing scenario)
    }
  }, [closeInventoryDialog]);

  useEffect(() => {
    if (closeSendInventoryDialog) {
      dispatch(setCloseSendInventoryDialog(false));
      setOpenSendDialog(false);
      setTableResetKey((k) => k + 1); // remount table → clears selection
      getInventory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeSendInventoryDialog]);

  // OPEN BULK SEND (selected rows)
  const handleSendBulk = () => {
    setTransferItems(
      (selectedRows || []).map((row: any) => ({
        id: row?.id,
        itemName: row?.itemName,
        stockLevel: row?.currentStock,
      })),
    );
    setIsSingleTransfer(false);
    setOpenSendDialog(true);
  };

  // SEND main inventory to a facility (single + bulk)
  const handleSendToFacility = (data: {
    target: string;
    facilityId: string;
    items: { id: string; quantity: number }[];
  }) => {
    dispatch(
      sendInventoryToFacility({
        facilityId: data?.facilityId,
        items: (data?.items || [])
          .filter((it) => Number(it?.quantity) > 0)
          .map((it) => ({ itemId: it?.id, quantity: Number(it?.quantity) })),
      }),
    );
  };

  // GET INVENTORY LIST
  const getInventory = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      searchValue: searchedValue?.trim(),
      type: categoryType || undefined,
      status:
        selectedTab === "lsa"
          ? "Low_Stock"
          : selectedTab === "oos"
          ? "Out_of_Stock"
          : undefined,
    };
    dispatch(getInventoryList(payload));
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  const handleAddInventoryData = (formData: Record<string, unknown>) => {
    const {
      batchNumber,
      itemId,
      itemName,
      purchaseUnit,
      quantity,
      stockKeepingUnit,
      supplierName,
      thresholdValue,
      type,
      unitOfMeasure,
    } = formData;
    const payload = {
      itemName: itemName,
      itemCode: itemId,
      type: type,
      unitOfMeasure: unitOfMeasure,
      quantity: quantity ? Number(quantity) : undefined,
      skuCode: stockKeepingUnit,
      threshold: thresholdValue ? Number(thresholdValue) : undefined,
      logisticsInfo: {
        name: supplierName,
        unit: purchaseUnit,
        batchNumber: batchNumber || undefined,
      },
    };
    if (defaultDataForInventory?.stockKeepingUnit) {
      // Edit mode: send the full field set so all fields (ID names, units,
      // supplier, batch, SKU) persist — not just quantity/threshold.
      const updateInventoryPayload = {
        apiPayload: payload,
        id: defaultDataForInventory?.id,
      };
      dispatch(updateInventoryList(updateInventoryPayload));
    } else {
      dispatch(addInventoryList(payload));
    }
  };

  const handleImportInventoryData = async (
    formData: Record<string, unknown>,
  ) => {
    await handleImportData(formData, {
      service: InventoryService.uploadInventoryFile,
      onRefresh: getInventory,
      asyncMessage:
        "Inventory import started successfully. You will be notified when it completes.",
      setIsImporting,
      setImportMessage,
      setImportResults,
      setOpenImportResultsDialog,
      setOpenImportInventoryDialog,
    });
  };

  // Helper function to convert file to base64
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        const base64Data = result.substring(result.indexOf(",") + 1);
        resolve(base64Data);
      };
      reader.onerror = (error) => {
        reject(
          new Error(
            `File reading failed: ${error instanceof Error ? error.message : "Unknown error"}`,
          ),
        );
      };
    });
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 flex flex-col"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col min-w-0 flex-1 min-h-0 gap-3">
        {/*  SCREEN HEADER */}
        <div className={`flex items-center justify-between w-full`}>
          <Heading title="Inventory Management" />
        </div>
        {/* MAIN CONTENT */}
        <div
          style={{
            overflow: "auto",
            flex: "1 1 0%",
            minHeight: 0,
            paddingRight: hasOverflow ? "7px" : "0",
          }}
          ref={divRef}
        >
          {/*  Cards */}
          {
            <div className="flex w-full gap-3 mb-4 mt-3">
              <EventEHRSimpleCard
                cardData={cardsData}
                handleClick={(data) => {
                  console.log("data:", data);
                }}
              />
            </div>
          }

          {/* TABS AND TAB WISE SCREEN HERE */}
          <div className="mt-3">
            {/* REUSABLE TAB COMPONENT */}
            <EventEHRTabs
              defaultSelectedValue={selectedTab}
              tabList={[
                { label: "All Inventory", value: "allInventory" },
                { label: "Low Stock Alerts", value: "lsa" },
                { label: "Out Of Stock", value: "oos" },
              ]}
              onChangeTab={(tab) => {
                setSearchValue("");
                setPageNumber(1);
                setRowPerPage("10");
                setSelectedTab(tab);
              }}
            />

            {/* IF SELECTED TAB IS ALLINVENTORY */}
            {selectedTab === "allInventory" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* CATEGORY FILTER */}
                  <div className="w-full sm:w-[180px]">
                    <SelectDropdown
                      label=""
                      name="categoryType"
                      placeholderValue="Select Category"
                      displayEmpty={true}
                      value={categoryType}
                      options={INVENTORY_TYPE_OPTIONS.filter((o) => o.value)}
                      onChangeCb={(e) => {
                        setPageNumber(1);
                        setCategoryType(e.target.value);
                      }}
                    />
                  </div>
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by Item Name, ItemCode , Type, SKU Code"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                  {/* IMPORT INVENTORY BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px" }}
                        src={DownloadIcon}
                        alt={"Download"}
                        className="cursor-pointer w-[19px] h-[19px]"
                      />
                    }
                    label="Import Inventory"
                    variant="outlined"
                    onClickCb={() => {
                      setOpenImportInventoryDialog(true);
                    }}
                    style={{
                      ...commonButtonStyle,
                      backgroundColor: "white",
                      border: "1px solid #1976d2",
                      color: "#1976d2",
                    }}
                  />
                  {/* SEND BULK INVENTORY BUTTON */}
                  <Button
                    label={
                      selectedRows?.length
                        ? `Send Bulk Inventory (${selectedRows.length})`
                        : "Send Bulk Inventory"
                    }
                    variant="outlined"
                    disabled={!selectedRows?.length}
                    onClickCb={handleSendBulk}
                    style={{ ...commonButtonStyle, minWidth: "180px" }}
                  ></Button>

                  {/* ADD INVENTORY BUTTON */}
                  {
                    <Button
                      startIcon={
                        <img
                          style={{ height: "23px" }}
                          src={plusIcon}
                          alt={"search"}
                          className="cursor-pointer w-[19px] h-[19px]"
                        />
                      }
                      label="Add Inventory"
                      variant="contained"
                      onClickCb={() => {
                        // selectedTabForUser !== "Staff"
                        // ?
                        setDefaultDataForInventory({});
                        setOpenAddInventoryDialog(true);
                        // : {};
                      }}
                      style={commonButtonStyle}
                    ></Button>
                  }
                </div>

                <Table
                  key={tableResetKey}
                  columns={allInventoryTabColumns}
                  rows={inventoryRowData}
                  selectProps={{
                    isSelectable: true,
                    isSelectAll: true,
                    selectIdentifier: "id",
                    onSelectAll: () => {},
                    onSelectRowsCb: (rows: any) => setSelectedRows(rows),
                  }}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: (inventoryList as any)?.totalPages,
                    totalCount: (inventoryList as any)?.totalRecords,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: number) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: string) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS LOW STOCK ALERTS */}
            {selectedTab === "lsa" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* CATEGORY FILTER */}
                  <div className="w-full sm:w-[180px]">
                    <SelectDropdown
                      label=""
                      name="categoryType"
                      placeholderValue="Select Category"
                      displayEmpty={true}
                      value={categoryType}
                      options={INVENTORY_TYPE_OPTIONS.filter((o) => o.value)}
                      onChangeCb={(e) => {
                        setPageNumber(1);
                        setCategoryType(e.target.value);
                      }}
                    />
                  </div>
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by Item Name, ItemCode , Type, SKU Code"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                </div>
                <Table
                  columns={allInventoryTabColumns}
                  rows={inventoryRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: (inventoryList as any)?.totalPages,
                    totalCount: (inventoryList as any)?.totalRecords,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: number) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: string) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS OUT OF STOCK */}
            {selectedTab === "oos" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* CATEGORY FILTER */}
                  <div className="w-full sm:w-[180px]">
                    <SelectDropdown
                      label=""
                      name="categoryType"
                      placeholderValue="Select Category"
                      displayEmpty={true}
                      value={categoryType}
                      options={INVENTORY_TYPE_OPTIONS.filter((o) => o.value)}
                      onChangeCb={(e) => {
                        setPageNumber(1);
                        setCategoryType(e.target.value);
                      }}
                    />
                  </div>
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by Item Name, ItemCode , Type, SKU Code"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                </div>
                <Table
                  columns={allInventoryTabColumns}
                  rows={inventoryRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: (inventoryList as any)?.totalPages,
                    totalCount: (inventoryList as any)?.totalRecords,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: number) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: string) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* OPEN ADD INVENTORY DIALOG */}
      {openAddInventoryDialog && (
        <AddNewInventoryDialog
          dialogHeading={
            defaultDataForInventory?.stockKeepingUnit
              ? "Edit Inventory"
              : "Add New Inventory"
          }
          defaultDataForInventory={defaultDataForInventory}
          isOpen={openAddInventoryDialog}
          handleClose={() => setOpenAddInventoryDialog(false)}
          handleAddInventoryData={(formData: Record<string, unknown>) => {
            handleAddInventoryData(formData);
          }}
        />
      )}

      {/* OPEN IMPORT INVENTORY DIALOG */}
      {openImportInventoryDialog && (
        <ImportInventoryDialog
          dialogHeading="Import Inventory"
          isOpen={openImportInventoryDialog}
          handleClose={() => {
            setOpenImportInventoryDialog(false);
            setImportMessage(null);
          }}
          handleImportInventoryData={(formData: Record<string, unknown>) => {
            handleImportInventoryData(formData);
          }}
          isImporting={isImporting}
          importMessage={importMessage}
        />
      )}
      <ViewInventoryDialog
        dialogHeading="View Inventory Details"
        handleClose={() => setOpenViewInventoryDialog(false)}
        inventoryData={defaultDataForInventory}
        isOpen={openViewInventoryDialog}
      />

      {/* SEND INVENTORY (main → facility only) */}
      {openSendDialog && (
        <SendInventoryDialog
          isOpen={openSendDialog}
          facilityOnly
          hideTable={isSingleTransfer}
          selectedItems={transferItems}
          dialogHeading={
            isSingleTransfer ? "Send Inventory" : "Send Bulk Inventory"
          }
          handleClose={() => setOpenSendDialog(false)}
          handleSend={(data) => handleSendToFacility(data)}
        />
      )}

      {/* Import Results Dialog */}
      <ImportResultsDialog
        isOpen={openImportResultsDialog}
        handleClose={() => {
          setOpenImportResultsDialog(false);
          setImportResults(null);
        }}
        results={importResults}
      />

      {openConfirmationDialog && (
        <EventEHRConfirmationDialog
          alertTitle="Delete Inventory"
          alertDescription="Are you sure you want to delete this Inventory? Please confirm to proceed."
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openConfirmationDialog}
          handleClose={(action) => {
            if (action === "close") {
              setOpenConfirmationDialog(false);
            } else if (action === "submit") {
              if (selectedInventoryId) {
                const payload = {
                  inventoryId: selectedInventoryId,
                  comesFrom: "",
                };
                dispatch(deleteInventory(payload));
              }
              // setOpenConfirmationDialog(false);
            }
          }}
        />
      )}
    </WrapperCard>
  );
};

export default InventoryScreen;
